/* 游民落地页「一天四景」的切换：左右箭头翻页，点时间轴上的圆盘直接跳。
 *
 * 三组元素各自带 data-starole-nomad-scenes-index（底图槽位 / 时间轴停靠点 / 玻璃卡片），
 * 谁在 DOM 里缺席都不影响——卡片只在填了标题时才渲染，所以按索引取而不是按下标取。
 * 初始选中态写在 Liquid 里（第 1 景），脚本跑起来后统一走 show()，避免首屏闪一下。
 */
(function () {
  'use strict';

  function collect(root, part) {
    var nodes = root.querySelectorAll('[data-starole-nomad-scenes-part="' + part + '"]');
    var map = {};
    for (var i = 0; i < nodes.length; i++) {
      map[nodes[i].getAttribute('data-starole-nomad-scenes-index')] = nodes[i];
    }
    return map;
  }

  function init(root) {
    var slides = collect(root, 'slide');
    var stops = collect(root, 'stop');
    var cards = collect(root, 'card');
    var indexes = Object.keys(slides);

    if (indexes.length < 2) return;

    var current = -1;

    function show(index) {
      if (index === current) return;
      current = index;

      for (var i = 0; i < indexes.length; i++) {
        var key = indexes[i];
        var on = Number(key) === index;

        slides[key].classList.toggle('is-active', on);

        if (stops[key]) {
          stops[key].classList.toggle('is-active', on);
          if (on) {
            stops[key].setAttribute('aria-current', 'true');
          } else {
            stops[key].removeAttribute('aria-current');
          }
        }

        if (cards[key]) {
          cards[key].classList.toggle('is-active', on);
          if (on) {
            cards[key].removeAttribute('aria-hidden');
          } else {
            cards[key].setAttribute('aria-hidden', 'true');
          }
        }
      }
    }

    function step(delta) {
      show((current + delta + indexes.length) % indexes.length);
    }

    indexes.forEach(function (key) {
      if (!stops[key]) return;
      stops[key].addEventListener('click', function () {
        show(Number(key));
      });
    });

    var prev = root.querySelector('[data-starole-nomad-scenes-nav="prev"]');
    var next = root.querySelector('[data-starole-nomad-scenes-nav="next"]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    show(0);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-starole-nomad-scenes]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
